import { ErrorView, PageLayout } from "@gearbox-protocol/ui-kit";
import { useQuery } from "@tanstack/react-query";
import { SkeletonBytecodeTable } from "@/components/bytecode/skeleton-bytecode-table";
import { BytecodeRepositoryListView } from "@/components/bytecode/view-bytecode-list";
import { BytecodeShort } from "@/core/bytecode";
import { ApiError } from "@/core/error";
import { fetchGearboxApi } from "@/utils/api-fetch";

export function BytecodeRepositoryPage() {
  const {
    data: bytecodes,
    error,
    isLoading,
  } = useQuery<BytecodeShort[], Error>({
    queryKey: ["bytecodes"],
    queryFn: async () => {
      return fetchGearboxApi<BytecodeShort[]>("/bcr", {
        errorMessage: "Failed to fetch bytecodes",
      });
    },
  });

  if (isLoading) {
    return (
      <PageLayout title="Bytecode Repository">
        <SkeletonBytecodeTable />
      </PageLayout>
    );
  }

  if (error) {
    const status = error instanceof ApiError ? error.status : 500;
    const message =
      error instanceof Error ? error.message : "Unknown error occurred";

    return <ErrorView status={status} message={message} />;
  }

  if (!bytecodes) {
    return <ErrorView status={500} message="No data available" />;
  }

  return <BytecodeRepositoryListView bytecodes={bytecodes} />;
}
